import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { Dispatch } from "react";

export interface Settings {
  email?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  id?: string;
}
type Disability = "dislexia" | "diopteres" | "contrast";
interface SettingsState {
  data: {
    disability: {
      dislexia: boolean;
      diopteres: boolean;
      contrast: boolean;
    };
  };
  loading: "idle" | "pending" | "succeeded" | "failed";
}

interface RootState {
  settings: SettingsState;
}

type ChangeDisability = {
  type: "settings/changeDisability";
  payload: "dislexia" | "diopteres" | "contrast";
};

const initialState: SettingsState = {
  data: {
    disability: {
      dislexia: false,
      diopteres: false,
      contrast: false,
    },
  },
  loading: "idle",
};

export const settingsReducer = createSlice({
  initialState,
  name: "settings",
  reducers: {
    changeDisability: (
      state: SettingsState,
      action: PayloadAction<"dislexia" | "diopteres" | "contrast">,
    ) => {
      state.data.disability[action.payload] =
        !state.data.disability[action.payload];
    },
  },
});

export const changeDisabilityFunc = ({
  disability,
}: {
  disability: "dislexia" | "diopteres" | "contrast";
}) => {
  return async (dispatch: Dispatch<ChangeDisability>) => {
    dispatch(changeDisability(disability));
  };
};

export const { changeDisability } = settingsReducer.actions;

export const userData = (state: RootState) => state.settings;

export default settingsReducer.reducer;
